import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import LinearProgress from "@material-ui/core/LinearProgress";
import {
  fetchPollStudentsAndLock
} from "../firebaseApi";
const styles = (theme) => ({});

function InstructorPollCheat(props) {
  let mobile = props.width === "sm" || props.width === "xs";
  const [loading, setLoading] = React.useState(false);
  
  function lockPoll() {
    setLoading(true);
    props.lock()
    let data = {courseID: props.course.courseID, sessionID: props.course.courseActivitySessionID, pollID: props.course.courseActivityPollID}
    fetchPollStudentsAndLock(data);
      setLoading(false);
      props.openCtl(false);
    
  }

  return (
    <Dialog
      fullScreen={mobile}
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={() => {
        props.openCtl(false);
      }}
    >
      <DialogTitle>{"Set Poll " + props.pollNumber + " as a lockout poll"}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Setting this poll as a lockout poll notifies students that they need to see the instructor to unlock their account (see "Lockout override" under settings)
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            props.openCtl(false);
          }}
        >
          Cancel
        </Button>

        <Button color="primary" onClick={lockPoll}>
          Continue
        </Button>
      </DialogActions>
      {loading ? <LinearProgress /> : null}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorPollCheat))
  )
);
